<!-- 顶部 购物车 -->
<template>
  <div class="cartclass">
    <a class="cart-menu-item" :href="cart.url" target="_blank">
      <img class="imgclass" :src="cart.icon" />
      <span class="cartname">{{ cart.name }}</span>
      <div>
        <span class="ci-count">{{ cartNum }}</span>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  computed: {
    cartNum: function () {
      return this.$store.state.cartNum;
    },
    cart: function () {
      return this.$store.state.malMainPageConfig.cart;
    },
  },
};
</script>

<style scoped lang="scss">
.cart-menu-item {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #ebeef5;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  position: relative;
  width: 106px;
  height: 40px;
}
.cartclass  {
  border-radius: 4px;
  border: 1px solid #2386ee;
}
.cart-menu-item :hover {
  border: 0;
  display: inline-flex;
}
.iconfont {
  color: #c81623;
  z-index: 999;
}
.iconfont :hover {
  border: 0;
  display: inline-flex;
}
.ci-count {
  position: absolute;
  bottom: 26px;
  left: 26px;
  display: inline-block;
  padding: 1px 3px;
  font-size: 12px;
  line-height: 12px;
  background-color: #e1251b;
  border-radius: 7px;
  min-width: 8px;
}
.ci-count :hover {
  border: 0;
  display: inline-flex;
}
.cartname {
  width: 48px;
  height: 21px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #2386ee;
  line-height: 21px;
}
.cartname :hover {
  border: 0;
  display: inline-flex;
}
.imgclass {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  display: inline-block;
  color: white;
  margin-left: 15px;
}
</style>
